import { ChangeDetectionStrategy, Component } from '@angular/core';

import { GlobalProductsRoutes } from '@hdms/shared/common-types';

@Component({
  selector: 'shrd-pf-ui-view-categories-link',
  templateUrl: './view-categories-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewCategoriesLinkComponent {
  readonly baseCategoryRoute = `/${GlobalProductsRoutes.BASE_CATEGORY_PAGE}?viewDetails=true`;
}
